import { render, staticRenderFns } from "./ClinicPatientCard.vue?vue&type=template&id=75d37010&scoped=true"
import script from "./ClinicPatientCard.vue?vue&type=script&lang=js"
export * from "./ClinicPatientCard.vue?vue&type=script&lang=js"
import style0 from "./ClinicPatientCard.vue?vue&type=style&index=0&id=75d37010&prod&lang=scss&scoped=true"
import style1 from "./ClinicPatientCard.vue?vue&type=style&index=1&id=75d37010&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d37010",
  null
  
)

export default component.exports